import React from 'react';
import { Grid, Stack } from '@mantine/core';
import {
  getMainColumnSpanValues,
  getRowColumnSpanValues,
  spanPropForGrid,
} from '../../../utils/proposalSectionNested';
import { applyStackBreakpointToSpans, stackBreakpointsProp } from '../../../utils/proposalSectionColumns';
import { resolveSectionGap } from '../../../utils/proposalSectionGaps';
import SectionColumnDropZone from './SectionColumnDropZone';
import { columnColProps } from './sectionColumnStyles';
import styles from './ProposalSection.module.css';

/**
 * Grille imbriquée : colonnes principales → lignes → colonnes (zones Puck).
 * Hauteur des lignes = contenu (min. zone vide uniquement en édition).
 * columnGap/rowGap : longueurs CSS rem — absent = 16 px, '' = 0
 * (resolveSectionGap). stackAtPx : point d'empilement (viewport ≤ px).
 */
export default function ProposalSectionNestedGrid({
  nested,
  className,
  isEditing = false,
  sectionId,
  columnGap,
  rowGap,
  stackAtPx,
  columnStyles = null,
  columnsJustify = 'flex-start',
}) {
  const mainSpans = applyStackBreakpointToSpans(getMainColumnSpanValues(nested), stackAtPx);
  const minEmptyHeight = isEditing ? 48 : 0;
  const gutter = resolveSectionGap(columnGap);
  const stackGap = resolveSectionGap(rowGap);
  const gridBreakpoints = stackBreakpointsProp(stackAtPx);

  return (
    /* Mantine v8 : pas de prop gutter — columnGap/rowGap explicites. */
    <Grid
      columnGap={gutter}
      rowGap={stackGap}
      breakpoints={gridBreakpoints}
      className={`${className} ${styles.nestedGrid}`}
    >
      {nested.mainColumns.map((mainCol, mainIdx) => (
        <Grid.Col
          key={mainCol.id}
          {...columnColProps(columnStyles, mainCol.id, spanPropForGrid(mainSpans[mainIdx]))}
        >
          <Stack gap={stackGap} className={styles.nestedMainStack}>
            {(mainCol.rows || []).map((row) => {
              const rowSpans = applyStackBreakpointToSpans(getRowColumnSpanValues(row), stackAtPx);
              return (
                <div key={row.id} className={styles.nestedRow}>
                  <Grid
                    columnGap={gutter}
                    rowGap={stackGap}
                    breakpoints={gridBreakpoints}
                    justify={columnsJustify}
                    className={styles.nestedRowGrid}
                  >
                    {(row.columns || []).map((cell, cellIdx) => (
                      <Grid.Col
                        key={cell.id}
                        {...columnColProps(columnStyles, cell.id, spanPropForGrid(rowSpans[cellIdx]))}
                      >
                        <SectionColumnDropZone
                          isEditing={isEditing}
                          sectionId={sectionId}
                          colId={cell.id}
                          className={styles.nestedDropZone}
                          minEmptyHeight={minEmptyHeight}
                          collisionAxis="y"
                        />
                      </Grid.Col>
                    ))}
                  </Grid>
                </div>
              );
            })}
          </Stack>
        </Grid.Col>
      ))}
    </Grid>
  );
}
